import { useCallback } from 'react';
import useContextMenu from 'src/hooks/useContextMenu';
import useUpdateStore from 'src/hooks/useUpdateStore';
import { EVENT_TYPES } from 'src/interfaces/enums';
import ApplicationService from 'src/services/ApplicationService';

function useSyncStoreEvents() {
  const {
    updatePauseInStore,
    updateFullscreenInStore,
    updateReadyInStore,
    updatePlaybackRateInStore,
    updatePlaylistInStore,
    updateMarkersInStore,
    updateHasNativeHLSInStore,
    updateActiveSubtitleInStore,
    updateSubtitlesInStore,
    updatePictureInPictureStatusInStore,
    updateUserActiveInStore,
    updateVolumeInStore,
  } = useUpdateStore();

  const { showContextMenu } = useContextMenu();

  const createSyncStoreListeners = useCallback(() => {
    const player = ApplicationService.player;
    if (!player) return;

    document.addEventListener('fullscreenchange', () => {
      updateFullscreenInStore();
    });

    player.addEventListener(EVENT_TYPES.RATE_CHANGE, () => {
      updatePlaybackRateInStore();
    });
    player.addEventListener(EVENT_TYPES.ENTERPICTUREINPICTURE, () => {
      updatePictureInPictureStatusInStore();
    });
    player.addEventListener(EVENT_TYPES.LEAVEPICTUREINPICTURE, () => {
      updatePictureInPictureStatusInStore();
    });
    player.addEventListener(EVENT_TYPES.SUBTITLE_CHANGE, updateActiveSubtitleInStore);
    player.addEventListener(EVENT_TYPES.CONTEXT_MENU, showContextMenu);

    player.addEventListener(EVENT_TYPES.PLAY, () => updatePauseInStore(false));
    player.addEventListener(EVENT_TYPES.PAUSE, () => updatePauseInStore(true));
    player.addEventListener(EVENT_TYPES.LOADED_METADATA, updatePlaylistInStore);
    player.addEventListener(EVENT_TYPES.LOADED_METADATA, updateHasNativeHLSInStore);
    player.addSubtitleListener(updateSubtitlesInStore);
    player.addEventListener(EVENT_TYPES.READY, updateReadyInStore);
    player.addEventListener(EVENT_TYPES.LOADED_METADATA, updateMarkersInStore);

    player.addEventListener(EVENT_TYPES.USER_ACTIVE, () => {
      updateUserActiveInStore(true);
    });

    player.addEventListener(EVENT_TYPES.USER_INACTIVE, () => {
      updateUserActiveInStore(false);
    });

    player.addEventListener(EVENT_TYPES.LOADED_METADATA, () => {
      updateSubtitlesInStore();
    });

    player.addEventListener(EVENT_TYPES.VOLUME_CHANGE, () => {
      updateVolumeInStore();
    });
  }, []);

  return { createSyncStoreListeners };
}

export default useSyncStoreEvents;
